import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { publicMethods, baseUrl } from '../globals';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, tap } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class MagicInsightsService {
  constructor(
    private http: HttpClient,
    private pubMethods: publicMethods,
    private auth: AuthenticationService
  ) {}

  isLoading = {
    loadingMagicInsightsModuleInfo: false,
  };

  getMagicInsightsModuleInfo(moduleId): Observable<any> {
    this.isLoading.loadingMagicInsightsModuleInfo = true
    const params = new HttpParams().set("moduleId", moduleId);
    return this.http
      .post(
        baseUrl + '/get_organisation_aira_module_details/',
        params,
        this.auth.helperGetVerifiedPostDict()
      )
      .pipe(
        tap(_ => _),
        catchError(this.pubMethods.handleError('loadMagicInsightsModuleInfo', [], this.isLoading))
      );
  }

  getMagicInsightsAvailableModules(): Observable<any> {
    this.isLoading.loadingMagicInsightsModuleInfo = true;
    return this.http
      .post(
        baseUrl + '/get_users_organisation_aira_modules/',
          {},
        this.auth.helperGetVerifiedPostDict()
      )
      .pipe(
        tap(_ => _),
        catchError(this.pubMethods.handleError('getMagicInsightsAvailableModules', [], this.isLoading))
      );
  }


}
